/*
 *
 * Fonctions globales au site
 *
 */

/*
 *
 * Ajoute les différentes propriétés aux liens
 */
jQuery(document).ready(function () {
	var base = $('base')[0].href;
	// Blank sur les liens externes
	$('a[href^=http]:not([href^="' + base + '"])').prop('target', '_blank').prop('rel', 'noopener');
	// Gérer les liens retour
	$(document).on('click', 'a.retour', function () {
		if (document.referrer.indexOf(location.protocol + '//' + location.hostname) == 0) {
			history.back();
			return false;
		}
	});
	// Popup foundation
	$('body').append('<div class="reveal-modal" data-reveal id="content-popup" style="display:none"></div>');
	$('a[target=popup]:not([href*=upload])').on('click', function() {
		$('#content-popup').foundation('reveal', 'open', addtpl(this.href,'contenu'));
		return false;
	});
	$(document).on('opened.fndtn.reveal', '[data-reveal]', function () {
		$(this).append('<a class="close-reveal-modal">&#215;</a>');
	});
});


/**
 * Permet d'ajouter un tpl à l'url passée en paramètre
 * @param  url Url à modifier
 * @param  tpl Nom du template à ajouter
 * @returns string url modifiée
 */
function addtpl(url, tpl) {
	url = url.replace(/#.*/, '');
	if (url.indexOf('tpl=') != -1)
		return url.replace(/tpl=[^&]+/, 'tpl=' + tpl);
	if (url.indexOf('?') == -1)
		return url + '?tpl=' + tpl;
	else
		return url + '&tpl=' + tpl;
}

/*
 *
 * Ajout du plugin clearing
 *
 */
jQuery(document).ready(function () {
	$('a[href$="jpg"], a[href$="jpeg"], a[href$="png"], a[href$="gif"]').each(function (i, item) {
		var $item = jQuery(item);
		if (!$item.prop('rel') && $item.parents('.clearing-thumbs').length == 0) {
			$item.attr('rel', 'czbox');
		}
	});
	$('a.print, .print a').click(function (e) {
		window.open(addtpl(this.href, 'print'));
		return false;
	});
	$('a.confirm').on('click', function (ev) {
		if (!confirm($(this).prop('title') + '\n\nVous confirmez ?')) {
			ev.preventDefault();
		}
	});

	Foundation.onImagesLoaded($('.rte img:not([class*=noauto])'), function () {
		var images = $('.rte img:not([class*=noauto])');
		images.each(function (index, img) {
			img = $(img);
			alignement = img.hasClass('gauche') ? 'gauche' : (img.hasClass('droite') ? 'droite' : (img.hasClass('centre') ? 'centre' : ''));
			if (!alignement) {
				switch (img.prop('align')) {
					case 'left':
						alignement = 'gauche';
						break;
					case 'right':
						alignement = 'droite';
						break;
					default:
						alignement = 'centre';
				}
			} else {
				img.removeClass(alignement);
			}
			var caption = '';
			if (img.prop('title')) {
				caption = $('<figcaption/>');
				caption.html(img.prop('title'));
			}
			var width = img.width();

			var fig = img.parents('figure');
			if (fig.length == 0) {
				fig = $('<figure class="th ' + alignement + '">');
				fig.append(img.clone());
				fig.append(caption);
				fig.css('max-width', width);
				img.replaceWith(fig);
			} else {
				$(fig).addClass('th ' + alignement).append(caption).css('max-width', width);
			}
		});
	});


	

});

/**
 *
 * Gestion des formulaires
 *
 */
var validation = []
function setupForms() {
	jQuery('body').on('change', 'form input, form select, form textarea', function (ev) {
		var formId = this.form.id;
		var field = $(this);
		var fieldId = field.attr('id');
		var re = /^=.+$/; // Confirmation du password
		if (validation[formId] && validation[formId][fieldId]) {
			var fieldIsValid = true;
			$(validation[formId][fieldId]).each(function (index, pattern) {
				var value = field.val();
				if (value) {
					if (re.test(pattern)) { // Confirmation du password
						var fieldToMatch = $('#' + pattern.substr(1));
						if (field.val() != fieldToMatch.val()) {
							fieldIsValid = false;
							return false;
						}
					} else {
						pattern = new RegExp(pattern);
						if (field.val().match(pattern) === null) {
							fieldIsValid = false;
							return false;
						}
					}
				} else if (field.attr('required')) {
					fieldIsValid = false;
					return false;
				}
			});
			if (fieldIsValid) {
				field.parent('div').removeClass('error');
				field.removeClass('error');
			} else {
				field.parent('div').addClass('error');
				field.addClass('error');
			}
		}
	});
	jQuery('body').on('submit', 'form', function (ev) {
	  var $this = jQuery(this);
    jQuery(this.elements).trigger('change');
		var valid = $this.find('fieldset div.error').length > 0 ? false : true;
		if (valid) {
      $this.find('.js-submit-loader').show();
    } else {
      $this.find('.js-submit-loader').hide();
    }
		return valid;
	});
}

/* Ajout aux favoris */
function addToFavorites(link) {
  pageTitle = document.title;
  pageURL = document.location;
  if (typeof window.external.AddFavorite != "undefined") {
    // Internet Explorer solution
    window.external.AddFavorite(pageURL, pageTitle);
  } else if (typeof window.sidebar != "undefined" && typeof window.sidebar.addPanel != "undefined") {
    // Mozilla Firefox solution
    window.sidebar.addPanel(pageTitle, pageURL, "");
  } else {
    // Opera solution
    if (typeof ( opera ) == "object") {
      link.rel = "sidebar";
      link.title = pageTitle;
      link.url = pageURL;
      return true;
    } else {
      // The rest browsers (i.e Chrome, Safari)
      alert('Appuyer sur ' + ( navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Cmd' : 'Ctrl' ) +
        '+D Pour ajouter cette page à vos favoris.');
    }
  }
  return false;
}
